import { useState } from 'react';
import { Link } from 'react-router-dom';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9qr8h4nlsngrm4lm4i0';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const response = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setErrorMsg('订阅失败，请稍后重试');
          setStatus('error');
        } else {
          setErrorMsg(serverMsg);
          setStatus('error');
        }
      }
    } catch {
      setErrorMsg('网络错误，请检查网络连接后重试');
      setStatus('error');
    }
  };

  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20golden%20and%20deep%20red%20curves%2C%20modern%20minimalist%20sports%20theme%20with%20dynamic%20energy%20waves%2C%20elegant%20dark%20accents%2C%20cinematic%20atmosphere%20with%20soft%20glow%20effects%2C%20premium%20and%20professional%20aesthetic&width=1600&height=600&seq=cta-banner-haobo&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 to-foreground-950/80"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[600px] mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
            加入好博体育，开启您的赛事之旅
          </h2>
          <p className="text-sm text-white/70 mb-8 leading-relaxed">
            订阅我们的新闻通讯，第一时间获取最新赛事资讯、专业分析和专属福利
          </p>

          {status === 'success' ? (
            <div className="bg-accent-500/20 border border-accent-400/30 rounded-xl p-6">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-accent-400/30">
                <i className="ri-check-line text-2xl text-accent-300"></i>
              </div>
              <p className="text-white font-medium">订阅成功！感谢您的关注</p>
              <p className="text-sm text-white/60 mt-1">我们将会把最新赛事资讯发送到您的邮箱</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-[460px] mx-auto" data-readdy-form="">
              <div className="relative flex-1">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入您的邮箱地址"
                  required
                  className="w-full px-5 py-3 bg-white/15 backdrop-blur-sm border border-white/20 rounded-full text-white placeholder:text-white/40 text-sm focus:outline-none focus:border-accent-400 transition-colors"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-7 py-3 bg-accent-500 text-foreground-950 font-medium rounded-full hover:bg-accent-400 transition-colors disabled:opacity-60 whitespace-nowrap text-sm"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
              <div className="newsletter-honeypot">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
            </form>
          )}

          {status === 'error' && (
            <p className="text-sm text-red-300 mt-3">{errorMsg}</p>
          )}

          <div className="flex items-center justify-center gap-4 mt-8">
            <Link
              to="/about"
              className="px-6 py-2.5 bg-white/15 backdrop-blur-sm text-white text-sm font-medium rounded-full hover:bg-white/25 transition-all border border-white/20 whitespace-nowrap"
            >
              了解更多
            </Link>
            <Link
              to="/category/football"
              className="px-6 py-2.5 bg-accent-500 text-foreground-950 text-sm font-medium rounded-full hover:bg-accent-400 transition-all whitespace-nowrap"
            >
              立即体验
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}